import { TagDto } from "./tagDto";
import { UserDto } from "./userDto";

export class CustomerInfoDto {
	public customerId: string = "";
	public companyName: string = "";
	public surname: string = "";
	public givenName: string = "";
	public phone: string = "";
	public eMail: string = "";
	public street: string = "";
	public town: string = "";
	public plz: string = "";
	public country: string = "";
	public numberOfOrders: number = 0;
	public lastOrderDate: Date = new Date();
	public firstOrderDate: Date = new Date();
	public numberOfArtikel: number = 0;
	public totalAmountOrdered: number = 0;
	public active: boolean = true;
	public tags: TagDto[] = new Array<TagDto>();
	public registriertAm: Date = new Date();
	public users: UserDto[] = new Array<UserDto>();
	public customerMwstNumber: string | null = "";
	public defaultAdditionalOrderConfirmationEmail: string | null = "";
}
